import { Typography } from "@mui/material";
import styled from "styled-components";

export const StyledBox = styled.header`
  && {
    position: relative;
    width: 100%;
    max-width: 960px;
    margin: 0 auto;
    padding: 18px 18px;
    background-color: #ffffff;

    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const LogoImage = styled.img`
  && {
    width: 120px;
    height: 30px;
    object-fit: contain;
    display: block;

    position: absolute;
    top: 24px;
    left: 18px;
  }

  @media (max-width: 850px) {
    && {
      position: static;
      margin: 0 auto 12px;
    }
  }
`;

export const Title = styled(Typography).attrs({ as: "h1" })`
  && {
    margin: 0;
    font-family: Figtree, sans-serif;
    font-size: clamp(16px, 1.2vw + 12px, 18px);
    font-weight: 400;
    line-height: 1.4;
    text-align: center;
    color: #162a6b;
  }
`;

export const SubTitle = styled(Typography).attrs({ as: "p" })`
  && {
    margin: 4px 0 0;
    font-family: Figtree, sans-serif;
    font-weight: 800;
    font-size: clamp(24px, 2vw + 14px, 28px);
    line-height: 1.2;
    text-align: center;
    color: #162a6b;
  }
`;